// @ts-nocheck
import CustomerZoneJobDetail from '@/PageComponents/CustomerZone/CustomerZoneJob/CustomerZoneJobDetail';
import { createFileRoute } from '@tanstack/react-router';

export default CustomerZoneJobDetail;
export const Route = createFileRoute('/_customerzoneLayout/customerzone/viewjob')({ component: CustomerZoneJobDetail });
